import React from 'react';
import { 
  MdCalendarToday,
  MdCloudDownload, 
  MdGroups,
  MdLogin,
  MdMail,
  MdOpenInNew,
  MdPhotoCamera,
  MdPlace,
  MdFacebook
} from 'react-icons/md';
import { FaFacebook, FaInstagram } from 'react-icons/fa';
import file1 from "../assets/downloads/YCSC SACCOS Fomu ya Kujiunga.pdf";
import file2 from "../assets/downloads/YCSC SACCOS form ya maombi ya mkopo.pdf";
import file3 from "../assets/downloads/sample3.pdf";

export default function ContentSidebar() {
  const downloadFiles = [
    { filename: "Fomu ya Kujiunga.pdf", size: "155 KB", file:file1 },
    { filename: "Fomu ya Mkopo 2026.pdf", size: "215 KB", file: file2 },
    {filename: "Wasifu wa Kampuni ###", size: "1.2 MB", file: file3 }
    // { filename: "Sera Ndogo za SACCOS.pdf", size: "2.4 MB", file: file3 }
  ];

  const calendarEvents = [
    {
      date: "14",
      month: "Feb",
      day: "Jumamosi",
      title: "YCSC Community Day",
      location: "Eneo litakalopangwa na wanachama"
    },
    {
      date: "14",
      month: "Jun",
      day: "Jumapili",
      title: "Kikao cha Chama",
      location: "Udasa, Chuo Kikuu cha Dar es Salaam"
    },
    {
      date: "11",
      month: "Oct",
      day: "Jumapili",
      title: "Kikao cha Chama",
      location: "Udasa, Chuo Kikuu cha Dar es Salaam"
    },
    {
      date: "12",
      month: "Dec",
      day: "Jumamosi",
      title: "Sherehe ya Mwisho wa Mwaka",
      location: "Eneo litakalopangwa na wanachama"
    }
  ];

  const resourceLinks = [
    {
      label: "Mfumo wa Chama",
      url: "https://ycs.amala.app/#/login",
      icon: MdLogin
    },
    {
      label: "Webmail ya Chama",
      url: "http://www.ycscsaccos.co.tz/webmail",
      icon: MdMail
    },
    {
      label: "Instagram",
      url: "https://www.instagram.com/ycsc_saccos?igsh=MW5zMjA2NmI1ZWp1MA==",
      icon: FaInstagram
    },
    {
      label: "Facebook",
      url: "https://www.facebook.com/ycscsaccos",
      icon: FaFacebook
    }
  ];

  return (
    <aside className="ContentSidebar w-100 position-sticky">
      {/* BACKGROUND WATERMARKS - Mistari na Alama za Kifedha Nyuma */}
      <div className="sidebar-watermark-bg">
        <span className="watermark-symbol">$</span>
        <span className="watermark-symbol-secondary">YCSC</span>
      </div>

      <div className="sidebar-inner-container p-4 text-white position-relative z-index-3">

        {/* BLOCK 1: Kwa Nini Ujiunge */}
        <div className="sidebar-section sidebar-join-section mb-4">
          <h5 className="sidebar-title fw-bold text-uppercase mb-3">Kwa nini ujiunge?</h5>
          <div className="sidebar-divider mb-3"></div>
          <div className="sidebar-join-card p-3 rounded">
            <div className="d-flex align-items-center gap-2 mb-2">
              <MdGroups className="text-warning" size={20} />
              <span className="fw-bold">YCSC SACCOS LIMITED</span>
            </div>
            <p className="small text-white-75 mb-0">
              Ni mahali sahihi pa kiuchumi na kijamii kwa wanachama wake kwa kufuata sheria,
              kanuni na taratibu za vyama vya ushirika.
            </p>
          </div>
        </div>

        {/* BLOCK 2: Amala Portal CTA Box */}
        <div className="sidebar-amala-cta-box p-3 rounded mb-4 text-center">
          <div className="amala-badge mb-2 d-inline-block text-uppercase fw-bold">Amala Portal</div>
          <p className="small mb-3 text-white-50">
            Simamia michango, kagua salio na uombe mikopo saa 24/7 kidijitali.
          </p>
          <button 
            className="btn btn-sidebar-amala w-100 d-flex align-items-center justify-content-center gap-2"
            onClick={() => window.open("https://ycs.amala.app/#/login", "_blank", "noreferrer")}
          >
            <MdLogin size={16} />
            <span>Ingia Kwenye Mfumo</span>
          </button>
        </div>

        {/* BLOCK 3: Kituo cha Nyaraka (Downloads) */}
        <div className="sidebar-section mb-4">
          <h5 className="sidebar-title fw-bold text-uppercase mb-3">Nyaraka na Fomu</h5>
          <div className="sidebar-divider mb-3"></div>
          <div className="d-flex flex-column gap-2">
            {downloadFiles.map((file, idx) => (
              //{...(file.file === file3 ? {} : {download: file.filename})}
              <a href={file.file === file3 ? "" : file.file} {...(file.file === file3 ? {} : {download: file.filename})}  key={idx} className="download-item-card d-flex align-items-center gap-3 p-2.5 rounded">
                <div className="download-icon-box d-flex align-items-center justify-content-center text-primary">
                  <MdCloudDownload size={22} />
                </div>
                <div className="download-info flex-grow-1">
                  <div className="file-name text-light fw-semibold text-truncate">{file.filename}</div>
                  <span className="file-size text-white-50">{file.size}</span>
                </div>
              </a>
            ))}
          </div>
        </div>

        {/* BLOCK 4: Kalenda ya Matukio */}
        <div className="sidebar-section sidebar-calendar-section mb-4">
          <h5 className="sidebar-title fw-bold text-uppercase mb-3">Matukio Muhimu 2026</h5>
          <div className="sidebar-divider mb-3"></div>
          
          <div className="calendar-events-list d-flex flex-column gap-2">
            {calendarEvents.map((event, idx) => (
              <div key={idx} className="calendar-event-item d-flex gap-3 p-2 rounded">
                <div className="event-date-badge text-center">
                  <span className="event-date-day d-block fw-bold">{event.date}</span>
                  <span className="event-date-month d-block text-uppercase">{event.month}</span>
                </div>
                <div className="event-details flex-grow-1">
                  <div className="d-flex align-items-center gap-1 mb-1">
                    <MdCalendarToday className="text-warning flex-shrink-0" size={14} />
                    <span className="event-day text-white-50">{event.day}</span>
                  </div>
                  <div className="event-title fw-bold">{event.title}</div>
                  <div className="event-location d-flex gap-1 text-white-50">
                    <MdPlace className="flex-shrink-0 mt-1" size={14} />
                    <span>{event.location}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* BLOCK 5: Viungo Muhimu */}
        <div className="sidebar-section sidebar-links-section mb-0">
          <h5 className="sidebar-title fw-bold text-uppercase mb-3">Kurasa Zetu</h5>
          <div className="sidebar-divider mb-3"></div>
          <div className="sidebar-resource-links-list d-flex flex-column gap-2">
            {resourceLinks.map(({ label, url, icon: LinkIcon }) => (
              <a
                key={url}
                className="sidebar-resource-link d-flex align-items-center justify-content-between gap-3 p-2 rounded text-decoration-none"
                href={url}
                target="_blank"
                rel="noreferrer"
              >
                <span className="d-flex align-items-center gap-2 min-width-0">
                  <span className="resource-link-icon d-flex align-items-center justify-content-center flex-shrink-0">
                    <LinkIcon size={18} />
                  </span>
                  <span className="resource-link-label text-truncate">{label}</span>
                </span>
                <MdOpenInNew className="resource-link-open flex-shrink-0" size={16} />
              </a>
            ))}
          </div>

        </div>

      </div>
    </aside>
  );
}
